import { t } from 'ttag';

import { Response } from '@custom-types/Response';
import { UserSession, VerifyType } from '@custom-types/UserSession';
import apiFn from '@services/api-service';

export enum ErrorCode {
  InvalidEmailOrPassword = 'invalid_email_or_password',
  EmailNotPermitted = 'email_not_permitted',
  MaxAttempetsExceeded = 'max_attempts_exceeded',
  IncorrectPassword = 'IncorrectPassword',
  InvalidCode = 'invalid_or_expired_code',
  UnknownError = 'UnknownError',
}

export const errorMessages = (code?: ErrorCode) => {
  const messages = {
    [ErrorCode.InvalidEmailOrPassword]: t`The email/password combination provided is invalid.`,
    [ErrorCode.EmailNotPermitted]: t`This email doesn’t have access to this app.`,
    [ErrorCode.IncorrectPassword]: t`The password is incorrect. Please try again.`,
    [ErrorCode.MaxAttempetsExceeded]: t`Max attempts exceeded. Try again in 5 minutes.`,
    [ErrorCode.InvalidCode]: t`Invalid one time code.`,
    [ErrorCode.UnknownError]: t`Unknown error occurred`,
  };

  if (!code) {
    return messages[ErrorCode.UnknownError];
  }

  return messages[code] ?? messages[ErrorCode.UnknownError];
};

const api = () =>
  apiFn('/api/uapi/onsite-app', {
    Accept: 'application/vnd.eventmobi+json; version=p.7',
  });

export const authenticate = (payload: {
  email: string;
  stage: VerifyType;
  password?: string;
  oneTimeCode?: string;
}) =>
  api()
    .post('/login', { ...payload })
    .then((response: Response<UserSession>) => response.data.data);

export const sendEmailLink = (email: string) =>
  api()
    .post('/send-one-time-login-code', { email })
    .then((response: Response<UserSession>) => response.data.data);
